import React, { Component } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Summary from '../Summary';
import Resume from '../Resume';
import {
  formatCurrency,
  formatPercentage,
  formatDate,
  capitalize
} from '../../../../utils/FormatUtil';
import './liquidate.css';

class Liquidate extends Component {
  componentDidMount() {
    const { id, getTimeDeposit, getConfiguracionDap } = this.props;

    getTimeDeposit(id);
    getConfiguracionDap();
  }

  componentWillUnmount() {
    const { cleanLiquidate } = this.props;
    cleanLiquidate();
  }

  render() {
    const {
      timeDeposit,
      completed,
      email,
      account,
      timeDepositLiquidate
    } = this.props;

    return (
      <div className="dap-liquidar">
        <Row noGutters>
          <Col md={12}>
            <h6>
              <b>Liquidar Depósito a Plazo</b> número{' '}
              {timeDeposit.numeroDeposito}
            </h6>
          </Col>
        </Row>
        <Card body>
          <Row noGutters>
            <Col
              md={{ span: 4, offset: 1 }}
              sm={6}
              xs={12}
              className="table_result"
            >
              <h5>Detalle de la liquidacion</h5>
              <table className="table">
                <tbody>
                  <tr>
                  <th scope="col">Monto invertido</th>
                    <th scope="col">
                      {formatCurrency(
                        completed
                          ? timeDepositLiquidate.montoInvertido
                          : timeDeposit.capital
                      )}
                    </th>
                  </tr>
                  <tr>
                  <th scope="col">Ganancia</th>
                    <th scope="col">
                      {formatCurrency(
                        completed
                          ? timeDepositLiquidate.montoInteres
                          : timeDeposit.ganancia
                      )}
                    </th>
                  </tr>
                  <tr>
                  <th scope="col">Monto a liquidar</th>
                    <th scope="col">
                      {formatCurrency(
                        completed
                          ? timeDepositLiquidate.montoRescate
                          : timeDeposit.montoRescate
                      )}
                    </th>
                  </tr>
                  <tr>
                    <th>Plazo</th>
                    <th>
                      {timeDeposit.plazoPactado &&
                        `${timeDeposit.plazoPactado} días`}
                    </th>
                  </tr>
                  {timeDeposit.cuentaOrigen &&
                    timeDeposit.cuentaOrigen.numeroCuenta > 0 &&
                    timeDeposit.cuentaOrigen.tipo.startsWith('VI') && (
                      <tr>
                        <th>Cuenta de origen</th>
                        <th>{timeDeposit.cuentaOrigen.numeroCuenta}</th>
                      </tr>
                    )}
                  {!completed &&
                    timeDeposit.cuentaDestino &&
                    timeDeposit.cuentaDestino.numeroCuenta > 0 && (
                      <tr>
                        <th>Cuenta de destino</th>
                        <th>{timeDeposit.cuentaDestino.numeroCuenta}</th>
                      </tr>
                    )}
                  {completed && (
                    <tr>
                      <th>Cuenta de destino</th>
                      <th>
                        {timeDeposit.cuentaDestino &&
                        timeDeposit.cuentaDestino.numeroCuenta === 0
                          ? account
                          : timeDeposit.cuentaDestino.numeroCuenta}
                      </th>
                    </tr>
                  )}

                  <tr>
                    <th>Tipo de depósito</th>
                    <th className="dap-liquidar-tipo">
                      {capitalize((timeDeposit.tipoDeposito).toLowerCase())}
                    </th>
                  </tr>
                  <tr>
                    <th>Fecha de inicio</th>
                    <th>{formatDate(timeDeposit.fechaIngreso)}</th>
                  </tr>
                  <tr>
                    <th>Fecha de vencimiento</th>
                    <th>{formatDate(timeDeposit.fechaVencimiento)}</th>
                  </tr>
                  {completed && (
                    <tr>
                      <th>Fecha de Liquidacion</th>
                      <th>
                        {formatDate(timeDepositLiquidate.fechaLiquidacion)}
                      </th>
                    </tr>
                  )}
                  <tr>
                    <th><br></br></th>
                  </tr>        
                  <tr className="dap_verde">
                    <td>Tasa base</td>
                    <td>{formatPercentage(timeDeposit.tasaBase)}</td>
                  </tr>
                  <tr>
                    <th colspan="6">Tasa definida en base a un período de 30 días.</th>
                  </tr>
                  <tr className="dap_verde">
                    <td>Tasa período</td>
                    <td>{formatPercentage(timeDeposit.tasaPeriodo)}</td>
                  </tr>
                  <tr>
                    <th colspan="6">Tasa de interés total para todo el período estipulado en la captación. Resulta de la división de la Tasa Base por 30 y multiplicándola por el número de días de la Captación.</th>
                  </tr>
                  
                </tbody>
              </table>
              <div className="dap_scroll">
                <span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </span>
              </div>
            </Col>
            <Col
              md={{ span: 5, offset: 1 }}
              sm={6}
              xs={12}
              className="dap_border-izquierda"
            >
              <Col md={12} sm={12} xs={12}>
                {completed ? <Summary email={email} /> : <Resume />}
              </Col>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }
}

export default Liquidate;
